import Deleted from '../../assets/images/deleted.png'
import Orders from '../../assets/images/orders.png'
import Approved from '../../assets/images/approved.png'
import Pending from '../../assets/images/pending.png'

const Images = {
    Logo: require("../../assets/images/logo.png"),
    ArrowBack: require("../../assets/images/icons/arrow_back.png"),
}

export default Images

export {Deleted,Orders,Approved,Pending}